










































































































































































import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import GeneralTermDetailBase from "./GeneralTermDetailBase";

@Component
export default class GeneralTermDetail extends GeneralTermDetailBase {


    created() {
        this.returnRoute = "GeneralTermList";
        super.initializeRights('COR_GeneralTermsandCondition_Update', 'COR_GeneralTermsandCondition_Update', 'COR_GeneralTermsandCondition_Update', 'COR_GeneralTermsandCondition_Update');
        super.setMainDescription('generalTerm.new', 'generalTerm.detail');
        this.createdBase();
        this.mainDataChanged = false;
    }

    showContent() {
        return this.showEditButton && !this.styleFormNew && this.formData.consentDate == '';

    }

    showDowload() {
        return this.showEditButton && !this.styleFormNew;
    }

    isSuperUserAllow() {
        return this.isSuperUser;
    }

    showPublish() {
        return  this.formData.publicationDate =='';
    }

    publishTerm() {
        this.publishTermBase();
    }

    preventRefresh(event: any) {
        if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
            event.preventDefault(); event.returnValue = "";
        }
    }

    beforeMount() {
        window.addEventListener("beforeunload", this.preventRefresh);
    }

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.preventRefresh);
        this.$store.commit("formIsInEditMode", false);
        this.$store.commit("mainDataChanged", false);
    }

    mounted() {
        super.mounted();
    };

    update() {
        this.updateBase();
    }

    validate() {
        return this.validateBase();
    }

    isCorrectName(value: any) {
        this.isCorrectNameBase(value);
    }

    isCorrectMinDate(value: any) {
        this.isCorrectMinDateBase(value);
    }

    isCorrectMaxDate(value: any) {
        this.isCorrectMaxDateBase(value);
    }



    isCorrectFile(value: any) {
        this.isCorrectFileBase(value);
    }


    isCorrectNotificationDate(value: any) {
        this.isCorrectNotificationDateBase(value);
    }


}
